import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { urlFor, client } from '../../../lib/client';
import "./Categories.scss";

const Categories = ({headingText}) => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  console.log(categories)
  useEffect(() => {
    const query = '*[_type == "category"]';

    client.fetch(query).then((data) => {
      setCategories(data);
    });
  }, []);



  return (
    <div className="shop-by-categories">
       {<div className="sec-heading">{headingText}</div>}
      <div className="categories">
        {categories?.map((item) => (
          <div
            key={item._id}
            className="category"
            onClick={() => navigate(`/categories/${item?.brand}`)}
          >
            <img
              src={
                urlFor(item.image)
              } alt={item.brand}
            />
             <span className="name">{item.brand}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Categories;
